import { render, staticRenderFns } from "./AdminUserComponent.vue?vue&type=template&id=0ffce378&scoped=true"
import script from "./AdminUserComponent.vue?vue&type=script&lang=js"
export * from "./AdminUserComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminUserComponent.vue?vue&type=style&index=0&id=0ffce378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffce378",
  null
  
)

export default component.exports